import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploadMode } from 'devextreme/ui/file_uploader';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],

})
export class FileUploadComponent {
  @Input() selectButtonText: string = "Browse or drop files here";
  @Input() labelText: string = "Browse or drop files here";
  @Input() accept: string = "*";
  @Input() fileUploadMode: FileUploadMode = "instantly";// "useButtons";
  @Input() multiple: boolean = true;
  @Input() isEditable: boolean = true;

  @Output() onFileUploadEventEmitter: EventEmitter<File> = new EventEmitter();
  @Output() onFileRemoveEventEmitter: EventEmitter<File> = new EventEmitter();

  files: File[] = [];
  allowCancelling: boolean = true;

  clearAllFiles() {
    this.files.length = 0;
  }

  onFileUpload(file: File, progressCallBack: any) {
    if (this.isEditable) {
      this.onFileUploadEventEmitter.emit(file);
    }
    else {
      this.onFileUploadEventEmitter.emit(null);
    }
  }

  onValidateFileAttachments(e: any): boolean {
    return this.files.length > 0;
  }

  constructor() {
    this.onFileUpload = this.onFileUpload.bind(this);
  }

  removeFile(file: File): void {
    this.files = this.files.filter(f => f !== file);
    this.onFileRemoveEventEmitter.emit(file);
  }
}
